export default __webpack_public_path__ + "static/media/ic_exam_info_one_try.8ac01349.svg";